export function getDwellings(app) {
  return app?.number_of_new_dwellings || app?.dwelling_count || null;
}

export function getStoreys(app) {
  return app?.number_of_storeys || app?.storeys || null;
}
